<template>
  <main id="bill-of-lading-main">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('customerService.billOfLading.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter"/>
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" v-if="!billOfLading.isInBulkPrinting" class="default-section-title">
              {{ $t('customerService.billOfLading.summaryTitle') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="6" v-if="billOfLading.isInBulkPrinting" class="default-section-title">
              <div class="single-title"> {{ $t('customerService.billOfLading.selectBolsToPrint') }} </div>
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
              <add-bill-of-lading v-if="!billOfLading.isInBulkPrinting" />
              <print-bill-of-lading-bulk />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import AddBillOfLading from '@/views/customerCenter/billOfLading/components/AddBillOfLading';
import PrintBillOfLadingBulk from '@/views/customerCenter/billOfLading/components/PrintBillOfLadingBulk';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';


export default {
  name: 'BillOfLading',
  components: {
    AddBillOfLading,
    SearchFilter,
    SearchSummary,
    PrintBillOfLadingBulk
  },
  computed: {
    ...mapGetters(['billOfLading']),
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>
